import React, { Component } from 'react'; 
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import findIndex from 'lodash/findIndex';
import Checkbox from 'rc-checkbox';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; 
import * as actionCreators from '../../modules/actions/index';
import moment from 'moment';
import AttendeeItem from './AttendeeItem';
import {groupContentFields, groupPrivacyStatusDesc,uploadPreview,whiteLabelStyling, eventRoles} from  '../../utils/constants';
import { Modal, ModalBody,ModalHeader, Alert, Button, Label, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Row, Col, Input } from 'reactstrap'
import './EventGuestListModal.css'
import InvitedList from './InvitedList';
import RsvpList from './RsvpList';
import noEventUsers from '../../assets/onboarding/wStory.svg'

class EventGuestListModal extends Component {

	constructor(props) {
    super(props);
			this.state = { 
				results:[],
        curr_menu:this.props.u_status?this.props.u_status :0,
        isSuccess:false,
        removedItem:null,
        isUserRemoved:false,
        invited:[],
        going:[],
        interested:[],
        archived:[],
        isInvited:false,
        isInterest:false,
        isGoing:false,
        isArchived:false
		  }
    }


componentDidMount(){
   let{curr_menu}=this.state 
   if(curr_menu==0){
     this.checkEventList(0)
   } else if (curr_menu==1) {
     this.checkEventList(1)
   } else if (curr_menu==2) {
     this.checkEventList(2)
   } else if (curr_menu==3) {
    this.checkEventList(3)
  }
}


checkEventList=(status)=>{
  let{isInvited,isInterest,isGoing,isArchived}=this.state
  // this.getUsers(status)
  if( !isInvited || !isInterest ||  !isGoing || !isArchived){
    this.getUsers(status)
  }
  
}



getUsers=(status)=>{
  let payload ={
    eventId:this.props.match.params.id, 
    role: status,
    noLoader:true
    // organizationId: this.props.item.organizationID
  }
  let that=this
  axios.post(url.findEventGuests,  payload).then(resp => {
    let obj={}
    if(status==0){
      obj={...obj, invited:resp.data.data, isInvited:true}
    } else if (status==1){
      obj={...obj, interested:resp.data.data, isInterest:true}
    } else if (status==2) {
      obj={...obj, going:resp.data.data, isGoing:true}
    } else if (status==3) {
      obj={...obj, archived:resp.data.data, isArchived:true}
    }
    that.setState(obj)
  }).catch(error => {
    console.log(error);
    this.setState({error: true, errorMessage: 'Failed to add tool. Please try again.'});
  });
}


removeRsvp= (user, isRemoved, eventStatus, event_user) =>{
  isRemoved = ((event_user.isArchived && event_user.isArchived.value) || curr_menu==3)?false:true
 
  let{curr_menu}=this.state,
  
  payload = {
    conditions: {
      organizationId:user.organizationId,
      eventId:this.props.match.params.id?this.props.match.params.id: this.props.event._id, 
      userId:user._id,
    },
    event_user,
    updatedData:{ },
    rsvpStatus:curr_menu==0?'invitee_count':curr_menu==1?'interested_count':curr_menu==2?'going_count':'',
    isRemoved,
    noLoader:true
  };

  if(payload.rsvpStatus=='' || curr_menu==3 || !isRemoved){
    let{rsvp}=event_user,
    {value}=rsvp  // original rsvp in event_user.rsvp

    payload.rsvpStatus ='invitee_count' // payload.rsvpStatus = value==0?'invitee_count':value==1?'interested_count':value==2?'going_count':''
   
    payload.updatedData = {
      ...payload.updatedData, 
      rsvp: { value: 0, label: 'Invited', date: new Date() },
      "isArchived.value":false,
      'isRestored.value':true, 
      'isRestored.date':new Date()
    }
    
  } else {
    payload.updatedData = {
      ...payload.updatedData, 
      'isRestored.value':false, 
      "isArchived.value":true,
      "isArchived.date":new Date(),
    }
  }

  let that=this;
  // this.setState({isRemoved:true})
  axios.post(url.removeRsvp, payload).then(({ data }) => {	
    
    let {updated_event} = data.data,
    
    updateState={
                    removedItem:user,
                    isSuccess:true,
                    isUserRemoved:true
                  }

    // if(isRemoved){
    //   updateState={
    //               ...updateState,
    //               archived: [user, ...this.state.archived]
    //             }
    // }

    if(curr_menu==0){
      updateState={
        ...updateState,
        invited: that.state.invited.filter(e=> e.userId._id != user._id)
      }
    }else if(curr_menu==1){
      updateState={
        ...updateState,
        interested: that.state.interested.filter(e=> e.userId._id != user._id)
      }
    }else if(curr_menu==2){
      updateState={
        ...updateState,
        going: that.state.going.filter(e=> e.userId._id != user._id)
      }
    } else if(curr_menu==3){
      updateState={
        ...updateState,
        archived: that.state.archived.filter(e=> e.userId._id != user._id)
      }
    }

    
    if(!isRemoved || curr_menu==3){
      updateState={
        ...updateState,
        isGoing:false,
        isInvited:false,
        isInterest:false,
        isUserRemoved:false
      }
    }


    that.setState(updateState)
    let tool_attr = [
      'invitee_count', 'attendee_count', 'rsvp_count', 'interested_count','going_count',
    ],

    updated_item = Object.keys(updated_event)
                      .filter(e=> tool_attr.indexOf(e)>-1)
                      .reduce((acc, key)=>{ acc[key]=updated_event[key]; return acc}, {})


    that.props.onToolInfoCompleted(updated_item);
    that.props.updateEventRsvp(updated_item)
  });
}

viewMember=user=>{
let link = `/home/${this.props.user.profile.organizationId._id}/profile/${user.userId}`
this.props.history.push(link);
}
 
getInitials=(user)=>{
  let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
  let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
  return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
}

menuClick=curr_menu=>{
  this.setState({curr_menu})
  this.checkEventList(curr_menu)
}

checkUserRemove=(event, user)=>{
  if(event){
    let{isArchive}=event
    if(!isArchive || (isArchive && isArchive.value!=true)){
      let{invitedUsers,createdBy}=event
      if(createdBy && createdBy._id && createdBy._id == user._id){
        return true
      }
      if(invitedUsers && invitedUsers.length>0){
        return invitedUsers.filter(e=> e.value == user._id).length>0
      }
    } else {
      return false
    }
  }
  return false
}


renderListView=()=>{
  let{results,isSuccess,interested,going, curr_menu, invited,archived, rsvps, isInvited,isArchived, isInterest, isGoing}=this.state
  let{event, user}=this.props

  let canRemove = this.checkUserRemove(event, user)
  console.log('invited --- ', invited)

  if(curr_menu==0){
    return invited.length>0? <InvitedList event={this.props.event}
     canRemove ={canRemove} removeRsvp={this.removeRsvp} curr_menu={curr_menu}
     is_module={'RSVP'} results={invited}/>: this.renderNoData(isInvited)
  }else {
    let isBool
    if(curr_menu==1){
      results = interested
      isBool = isInterest
    }else if(curr_menu==2){
      results = going
      isBool = isGoing
    }else if(curr_menu==3){
      results = archived
      isBool = isArchived
    }
    return results.length>0? <RsvpList curr_menu={curr_menu} event={this.props.event} canRemove ={canRemove} removeRsvp={this.removeRsvp}
     is_module={'RSVP'} results={results}/>: this.renderNoData(isBool)
  }
}

renderNoData= isAPI =>{
  let{curr_menu}=this.state
  let str = curr_menu==0?'been invited':curr_menu==3? 'been removed': curr_menu==1?'indicated they are interested':'indicated they are going'
  if(isAPI){
    return(
      <div className="event_guest_modal_no_data">
        <img src={noEventUsers} className="event_guest_modal_no_data_img"/>
        <span className="event_guest_modal_no_data_txt">No users have {str}</span>
      </div>
    )
  } else {
      return(<div className="event_guest_modal_loading">
        <span>Loading...</span>
      </div>)
  }
  
}

onDismiss=()=>{
  this.setState({isSuccess:false})
}

renderMembers = (tasks) => {
  let{isSuccess,removedItem, isUserRemoved,curr_menu}=this.state
  let{event, user}=this.props

  let canRemove = this.checkUserRemove(event, user)
  return (
        <span>
          <Modal isOpen={this.props.isOpen} className="ent-obj-link-modal groupItemsModal event_guest_list_modal">
					<ModalHeader className="" charCode="X"
						toggle={this.props.closeGuestList}
						>
						<div className="dashboardModalTitle">
            <span className="event_details_modal_event_name">Guests </span>
						</div>
					</ModalHeader>
					<ModalBody className="create-stories">
          {isSuccess && removedItem && removedItem.firstName? <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
                        <strong>{removedItem.firstName} {removedItem.lastName?removedItem.lastName:''}</strong> was {isUserRemoved?'removed':'restored'}.
                      </Alert> :null}

            <div className="event_user_container_list" id="event_user_container_list" data-searchable="data-searchable">

              <span onClick={()=>this.menuClick(0)} className={`event_user_container_list_menu ${curr_menu==0 ?'event_guest_list_menu_selected':''} `}>
                Invited
                {curr_menu==0 ? <span className="event_guest_list_modal_menu_line"/> :null}
              </span>  

              <span onClick={()=>this.menuClick(1)} className={`event_user_container_list_menu ${curr_menu==1 ?'event_guest_list_menu_selected':''} `}>
                Interested
                {curr_menu==1? <span className="event_guest_list_modal_menu_line"/> :null}
              </span>

              <span onClick={()=>this.menuClick(2)} className={`event_user_container_list_menu ${curr_menu==2 ?'event_guest_list_menu_selected':''} `}>
                Going
                {curr_menu==2? <span className="event_guest_list_modal_menu_line"/> :null}
              </span>

              {canRemove?<span onClick={()=>this.menuClick(3)} className={`event_user_container_list_menu ${curr_menu==3 ?'event_guest_list_menu_selected':''} `}>
                Removed
                {curr_menu==3? <span className="event_guest_list_modal_menu_line"/> :null}
              </span>:null}

              {this.renderListView()} 

            </div>

            <div className="singleTaskModalBtn"
						style={{ padding: '10px 0px 0px 0px' }}>

					

							<Button className="profile-modal-cancel-btn weeklyWinBtn" onClick={this.props.closeGuestList}>
							<span className="profile-modal-cancel-btn-txt">Close</span>
							</Button>


						</div>
            </ModalBody>
            </Modal>
        </span> 
      )
};
 

	render() {
       let{users}=this.state

       return (<span className="event_details_page_attendees_section"> 
                <div className="event_details_page_attendees_section_containers_meta">
                  {this.renderMembers()} 
                </div>   
             </span>)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
    onToolInfoCompleted: (data) => dispatch(actionCreators.toolInfoCompleted(data)),
	}
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventGuestListModal));


  
  